import React, { FC, ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";

import { AppContext, AppProvider } from "./app-context";
import HeaderConfig from "./main/components/header-config/header-config";
import Page from "./main/components/page/page";
import { generateNonce } from "./utils/generate-nonce";

const nonce = generateNonce();

const RequireVerified: FC<{ children?: ReactNode }> = ({ children }) => {
  const { account } = useContext(AppContext);
  return account?.isVerified ? (
    <>{children}</>
  ) : (
    <Page inputs={[account]}>
      <Navigate to={"/choose-account/"} />
    </Page>
  );
};

interface AppRouteProps {
  requireVerified?: boolean;
  allowAnonymous?: boolean;
  children?: ReactNode;
}

export const AppRoute = ({ requireVerified = false, allowAnonymous = false, children }: AppRouteProps) => (
  <AppProvider requireAccount={!allowAnonymous}>
    <HeaderConfig nonce={nonce} />
    {requireVerified ? <RequireVerified>{children}</RequireVerified> : children}
  </AppProvider>
);
